<template>
  <el-menu class="sidebar" :default-active="defaultActive" @select="selectMenu" :router='true'>
    <div v-if="$store.getters.authorityRoute == '/parent'">
      <template v-for="(item,index) in laMenuList">
        <el-menu-item  v-if="item.children.length == 0" :key="index" :index="item.index">
          <img class="menu-img" :src="item.icon"/> {{ item.label }}
        </el-menu-item>
        <el-submenu v-else :key="index + item.label" :index="item.label">
              <template slot="title">
                <span class="wordWrap">{{item.label}}</span>
              </template>
              <el-menu-item v-for="items in item.children" :key="items.label"  :index="items.index">{{items.label}}</el-menu-item>
        </el-submenu>
      </template>
    </div>
    
    <div v-if="$store.getters.authorityRoute == '/admin'">
      <template v-for="(item,index) in laMenuList">
        <el-menu-item  v-if="item.children.length == 0 && setRoleMenu(item.meta)" :key="index" :index="item.index">
          <img class="menu-img" :src="item.icon"/> {{ item.label }}
        </el-menu-item>
        <el-submenu v-if="item.children.length > 0 && setSubmenuRoleMenu(item.label)" :key="index + item.label" :index="item.label">
              <template slot="title">
                <span class="wordWrap">{{ getSubstringAfterChar(item.label,'to')}}</span>
              </template>
              <template v-for="items in item.children">
                <el-menu-item v-if="setRoleMenu(items.meta)" :key="items.label"  :index="items.index">
                  {{items.label}}
                </el-menu-item>
              </template>
        </el-submenu>
      </template>
    </div>
  </el-menu>
</template>

<script>
import { roleName } from '@/biz/static-data'
export default {
  data() {
    return {
      roleName: '',
      shopManager: '',
      roleSuperAdmin: '',
      parentMenuList:[
        {
          label:'主頁 Home',
          index:'/parent/home',
          icon:`${require('@/assets/images/home.png')}`,
          children:[]
        },
        {
          label:'我的帳戶 My Account',
          index:'/parent/account',
          icon:`${require('@/assets/images/account.png')}`,
          meta:[this.roleManagerId],
          children:[]
        },
        {
          label:'我的申請 My Application',
          index:'/parent/application',
          icon:`${require('@/assets/images/application.png')}`,
          meta:[this.roleManagerId],
          children:[]
        },
        {
          label:'快速連結 Quick Link',
          index:'/parent/link',
          icon:`${require('@/assets/images/link.png')}`,
          meta:[this.roleManagerId],
          children:[]
        },
        {
          label:'請求 Request',
          index:'/parent/request',
          icon:`${require('@/assets/images/request.png')}`,
          meta:[this.roleManagerId],
          children:[]
        },
      ],
      adminMenuList:[
        {
          label:'Dashboard',
          index:'/admin/dashboard',
          meta:[roleName.admin,roleName.manager],
          children:[]
        },
        {
          label:'User Account Setting',
          index:'/admin/userAccountSetting',
          meta:[roleName.admin,roleName.clerk,roleName.manager],
          children:[]
        },
        {
          label:'Admission to FS1 (P1)',
          index:'',  
          children:[
            {
              label:'Application List',
              index:'/admin/application/0',
              meta:[roleName.admin,roleName.manager,roleName.clerk],
            },
            {
              label:'Provide Offer',
              index:'/admin/providedOffer/0',
              meta:[roleName.admin,roleName.manager],
            },
            {
              label:'Interview List',
              index:'/admin/interviewList/0',
              meta:[roleName.admin,roleName.manager],
            },
            {
              label:'Template Manage',
              index:'/admin/templateManage/0',
              meta:[roleName.admin,roleName.manager],
            },
          ]
        },
        {
          label:'Interim Admission to FS1 (P1)',
          index:'',  
          children:[
            {
              label:'Application List',
              index:'/admin/application/6',
              meta:[roleName.admin,roleName.manager,roleName.clerk],
            },
            {
              label:'Provide Offer',
              index:'/admin/providedOffer/6',
              meta:[roleName.admin,roleName.manager],
            },
            {
              label:'Interview List',
              index:'/admin/interviewList/6',
              meta:[roleName.admin,roleName.manager],
            },
            {
              label:'Template Manage',
              index:'/admin/templateManage/6',
              meta:[roleName.admin,roleName.manager],
            },
          ]
        },
        {
          label:'Interim Admission to FS2 (P2)',
          index:'',
          children:[
            {
              label:'Application List',
              index:'/admin/application/1',
              meta:[roleName.admin,roleName.manager,roleName.clerk],
            },
            {
              label:'Provide Offer',
              index:'/admin/providedOffer/1',
              meta:[roleName.admin,roleName.manager],
            },
             {
              label:'Interview List',
              index:'/admin/interviewList/1',
              meta:[roleName.admin,roleName.manager],
            },
            {
              label:'Template Manage',
              index:'/admin/templateManage/1',
              meta:[roleName.admin,roleName.manager],
            },
          ]
        },
        {
          label:'Interim Admission to DS1(P3-P4)',
          index:'',
          children:[
            {
              label:'Application List',
              index:'/admin/application/7',
              meta:[roleName.admin,roleName.manager,roleName.clerk],
            },
            {
              label:'Provide Offer',
              index:'/admin/providedOffer/7',
              meta:[roleName.admin,roleName.manager],
            },
             {
              label:'Interview List',
              index:'/admin/interviewList/7',
              meta:[roleName.admin,roleName.manager],
            },
            {
              label:'Template Manage',
              index:'/admin/templateManage/7',
              meta:[roleName.admin,roleName.manager],
            },
          ]
        },
        {
          label:'Interim Admission to DS2 (P4-P5)',
          index:'',
          children:[
            {
              label:'Application List',
              index:'/admin/application/8',
              meta:[roleName.admin,roleName.manager,roleName.clerk],
            },
            {
              label:'Provide Offer',
              index:'/admin/providedOffer/8',
              meta:[roleName.admin,roleName.manager],
            },
             {
              label:'Interview List',
              index:'/admin/interviewList/8',
              meta:[roleName.admin,roleName.manager],
            },
            {
              label:'Template Manage',
              index:'/admin/templateManage/8',
              meta:[roleName.admin,roleName.manager],
            },
          ]
        },
        {
          label:'Interim Admission to DS3 (P6)',
          index:'',
          children:[
            {
              label:'Application List',
              index:'/admin/application/9',
              meta:[roleName.admin,roleName.manager,roleName.clerk],
            },
            {
              label:'Provide Offer',
              index:'/admin/providedOffer/9',
              meta:[roleName.admin,roleName.manager],
            },
            {
              label:'Interview List',
              index:'/admin/interviewList/9',
              meta:[roleName.admin,roleName.manager],
            },
            {
              label:'Template Manage',
              index:'/admin/templateManage/9',
              meta:[roleName.admin,roleName.manager],
            },
          ]
        },
        {
          label:'DS4(S1) Application',
          index:'',
          children:[
            {
              label:'Application List',
              index:'/admin/application/2',
              meta:[roleName.admin,roleName.manager,roleName.clerk],
            },
            {
              label:'Provide Offer',
              index:'/admin/providedOffer/2',
              meta:[roleName.admin,roleName.manager],
            },
             {
              label:'Interview List',
              index:'/admin/interviewList/2',
              meta:[roleName.admin,roleName.manager],
            },
            {
              label:'Template Manage',
              index:'/admin/templateManage/2',
              meta:[roleName.admin,roleName.manager],
            },
          ]
        },
        {
          label:'DS5(S2) Application',
          index:'',
           children:[
            {
              label:'Application List',
              index:'/admin/application/3',
              meta:[roleName.admin,roleName.manager,roleName.clerk],
            },
            {
              label:'Provide Offer',
              index:'/admin/providedOffer/3',
              meta:[roleName.admin,roleName.manager],
            },
             {
              label:'Interview List',
              index:'/admin/interviewList/3',
              meta:[roleName.admin,roleName.manager],
            },
            {
              label:'Template Manage',
              index:'/admin/templateManage/3',
              meta:[roleName.admin,roleName.manager],
            },
          ]
        },
        {
          label:'MS1(S3) Application',
          index:'',
           children:[
            {
              label:'Application List',
              index:'/admin/application/10',
              meta:[roleName.admin,roleName.manager,roleName.clerk],
            },
            {
              label:'Provide Offer',
              index:'/admin/providedOffer/10',
              meta:[roleName.admin,roleName.manager],
            },
             {
              label:'Interview List',
              index:'/admin/interviewList/10',
              meta:[roleName.admin,roleName.manager],
            },
            {
              label:'Template Manage',
              index:'/admin/templateManage/10',
              meta:[roleName.admin,roleName.manager],
            },
          ]
        },
        {
          label:'MS2(S4) Application',
          index:'',
           children:[
            {
              label:'Application List',
              index:'/admin/application/4',
              meta:[roleName.admin,roleName.manager,roleName.clerk],
            },
            {
              label:'Provide Offer',
              index:'/admin/providedOffer/4',
              meta:[roleName.admin,roleName.manager],
            },
             {
              label:'Interview List',
              index:'/admin/interviewList/4',
              meta:[roleName.admin,roleName.manager],
            },
            {
              label:'Template Manage',
              index:'/admin/templateManage/4',
              meta:[roleName.admin,roleName.manager],
            },
          ]
        },
        {
          label:'MS3(S5)-HKDSE Application',
          index:'',
           children:[
            {
              label:'Application List',
              index:'/admin/application/11',
              meta:[roleName.admin,roleName.manager,roleName.clerk],
            },
            {
              label:'Provide Offer',
              index:'/admin/providedOffer/11',
              meta:[roleName.admin,roleName.manager],
            },
             {
              label:'Interview List',
              index:'/admin/interviewList/11',
              meta:[roleName.admin,roleName.manager],
            },
            {
              label:'Template Manage',
              index:'/admin/templateManage/11',
              meta:[roleName.admin,roleName.manager],
            },
          ]
        },
        {
          label:'MS3(S5)-IBDP Application',
          index:'',
          children:[
            {
              label:'Application List',
              index:'/admin/application/5',
              meta:[roleName.admin,roleName.manager,roleName.clerk],
            },
            {
              label:'Provide Offer',
              index:'/admin/providedOffer/5',
              meta:[roleName.admin,roleName.manager],
            },
             {
              label:'Interview List',
              index:'/admin/interviewList/5',
              meta:[roleName.admin,roleName.manager],
            },
            {
              label:'Template Manage',
              index:'/admin/templateManage/5',
              meta:[roleName.admin,roleName.manager],
            },
          ]
        },
        {
          label:'Quick Link',
          index:'/admin/quickLink',
          meta:[roleName.admin,roleName.manager],
          children:[]
        },
        {
          label:'Event Status Manage',
          index:'/admin/eventStatusManage',
          meta:[roleName.admin,roleName.manager],
          children:[]
        },
        {
          label:'Setting',
          index:'/admin/setting',
          meta:[roleName.admin,roleName.manager],
          children:[]
        },
        {
          label:'Request from Applicant',
          index:'/admin/requestFromApplicant',
          meta:[roleName.admin,roleName.manager],
          children:[]
        },
        {
          label:'Email Setup',
          index:'/admin/emailSetup',
          meta:[roleName.admin],
          children:[]
        },
        {
          label:'Email Log',
          index:'/admin/emailLog',
          meta:[roleName.admin],
          children:[]
        },
        {
          label:'UserActivity Logs',
          index:'/admin/userActivityLogs',
          meta:[roleName.admin],
          children:[]
        },
      ],
    }
  },
  computed: {
    defaultActive() {
      return this.$route.path
    },
    laMenuList(){
      return this.$store.getters.authorityRoute == '/parent' ?  this.parentMenuList : this.adminMenuList
    }
  },
  methods:{
    getSubstringAfterChar(str, char) {
      const index = str.indexOf(char);
      if (index === -1) {
          return str; 
      }
      let text = ''
      let start = str.substring(0,index)
      let end = str.substring(index+2);
      text += start
      text += 'to'
      text += '\n'
      text += end
      return text;
    },
    setSubmenuRoleMenu(label){
      if(this.userInfo.assignApplicationFormType ==null){
        return true
      }
      return this.userInfo.assignApplicationFormType.split(',').indexOf(label)>-1
    },
    setLabel(label){
      return label.split(' ')[0]
    },
    setRoleMenu(meta){
        if(meta.length>0){
            return meta.indexOf(this.userInfo.roleId)>-1
        } else {
          return false
        }
    },
    selectMenu(){
      this.$emit('selectMenu')
    },
    getAuthorityRoute(){
      const path = this.$route.path
      const re = /^(\/[^/]*)/g
      return re.exec(path)[1]
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebar {
  min-height: 100vh;
  height: 100%;
  text-align: left;
  font-size: 1.625rem;
  font-weight: bold;
  background-color: #F9FAFC;
}
.el-menu{
  background-color: #F9FAFC !important ;
}
.el-menu-item{
  background-color: #F9FAFC;
  margin-bottom: 0.5rem;
  font-size: 1.25rem;
  color: #696969;
  display: flex;
  align-items: center;
  
}
.is-active {
  background-color: #BAE4FF;
  color: #717171;
}
.menu-img{
  display: inline-block;
  width: 1.875rem;
  margin-right: 0.625rem;
}
::v-deep{
  .el-submenu__title{
    padding-left:3.6875rem !important;
    font-size: 1.25rem;
    height: auto;
    line-height: 1.5;
    color: #696969 !important;
    padding: 0.625rem 0;
  }
  .el-menu--inline{
    font-size: 0.9375rem;
  }
  .el-menu--inline .el-menu-item{
    font-size: 0.9375rem;
    display: flex;
    flex-direction: column;
    align-items:flex-start;
    padding-left:5.4375rem !important;
  }
}

</style>
